<template>
  <!-- 更新时间：2026-05-31 -->
  <!-- 功能说明：实验模拟器配置组件，用于配置科学实验模拟器页面 -->
  <!-- 配置项包括：页面标题、背景色、面板标题、面板背景、提示语等 -->
  <div class="card">
    <div class="card-title">5. 月球种植实验模拟器</div>
    <div class="row">
      <div class="label">头部标题</div>
      <input v-model="value.headerTitle" style="width:280px" :disabled="vimSave" />
    </div>
    <div class="row">
      <div class="label">头部背景色</div>
      <input v-model="value.headerBg" style="width:120px" disabled />
      <input type="color" v-model="value.headerBg" class="native-color-picker":disabled="vimSave" />
      
    </div>
    <div class="row">
      <div class="label">页面背景色</div>
      <input v-model="value.pageBg" style="width:120px" disabled />
      <input type="color" v-model="value.pageBg" class="native-color-picker" :disabled="vimSave"/>
      
    </div>
    <div class="row">
      <div class="label">面板标题</div>
      <input v-model="value.title" style="width:280px" />
    </div>
    <div class="row">
      <div class="label">面板背景色</div>
      <input v-model="value.bg" style="width:120px" disabled />
      <input type="color" v-model="value.bg" class="native-color-picker" :disabled="vimSave" />
      
    </div>
    <div class="row">
      <div class="label">提示语</div>
      <input v-model="value.tip" style="width:420px" :disabled="vimSave"/>
    </div>
  </div>
</template>

<script>
// 更新时间：2026-05-31
// 功能说明：实验模拟器配置组件逻辑
// 用于配置科学实验模拟器页面的外观显示，包括标题、背景色、提示语等
export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
	vimSave:{
		type: Boolean,
		default:false,
	}
  }
}
</script>

<style scoped>
.card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px #00000010;
}
.card-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
  color: #333;
}
.row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.label {
  width: 110px;
  font-size: 14px;
  color: #666;
}
input {
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
}
.color-preview {
	width: 20px;
	height: 20px;
	border-radius: 4px;
	border: 1px solid #ddd;
}

.native-color-picker {
	width: 30px;
	height: 30px;
	border: none;
	background: none;
	cursor: pointer;
	padding: 0;
}

.native-color-picker::-webkit-color-swatch-wrapper {
	padding: 0;
}

.native-color-picker::-webkit-color-swatch {
	border-radius: 4px;
	border: 1px solid #ddd;
}
</style>